import React, { FunctionComponent, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { Button } from 'reactstrap';

import styles from './Error.module.scss';

const InternalErrorPage: FunctionComponent = () => {
  const contactUs = import.meta.env.VITE_APP_CONTACT_US ?? '';
  const navigate = useNavigate();
  const contactWithMail = useCallback(
    () => (window.location.href = `mailto:${contactUs}?subject= Need Help`),
    [contactUs]
  );

  return (
    <div className={`d-flex flex-column ${styles.internalErrorContainer}`} data-testid="internal-error-content">
      <section className={styles.section2}>
        <div className={styles.containerFluid}>
          <div className="container">
            <div className="row">
              <div className="col-lg-2 bg-white pt-5 pb-4 py-lg-0">
                <span
                  className={`mt-n3 d-block d-lg-none text-primary-alt fw-medium  ${styles.firstInternalErrorText}`}
                >
                  500
                </span>
                <span
                  className={`mt-n2 d-none d-lg-inline-block d-xl-none display-2 text-primary-alt fw-medium ${styles.textOutlineSocgen}`}
                >
                  500
                </span>
                <span
                  className={`mt-n3 d-none d-xl-block display-1 text-primary-alt fw-medium ${styles.secondInternalErrorText}`}
                >
                  500
                </span>
              </div>
              <div className="col-lg-5  bg-white d-flex flex-column justify-content-between">
                <div>
                  <h1 className="d-none d-lg-block display-2 fw-medium line-height-1 pt-0 pb-3">
                    <FormattedMessage id="internalError" />
                  </h1>
                  <h1 className="d-lg-none display-3 fw-medium line-height-1 py-2">
                    <FormattedMessage id="internalError" />
                  </h1>

                  {/* MOBILE */}
                  <p className="d-lg-none mb-5 h3 fw-medium text-secondary line-height-1">
                    <FormattedMessage id="internalErrorMessage" />
                  </p>

                  {/* DESKTOP */}
                  <p className="d-none d-lg-block d-xxl-none display-3 fw-medium text-secondary w-75 line-height-1">
                    <FormattedMessage id="internalErrorMessage" />
                  </p>

                  {/* XXL */}
                  <p className="d-none d-xxl-block display-3 fw-medium text-secondary w-75 line-height-1">
                    <FormattedMessage id="internalErrorMessage" />
                  </p>
                </div>
                <div className="mb-5 d-none d-md-flex">
                  <Button className="btn btn-xl btn-primary" onClick={() => navigate(-1)} data-testid="try-again-md">
                    <FormattedMessage id="internalErrorTryAgain" />
                  </Button>
                  <Button
                    className="btn btn-xl btn-flat-secondary ms-1"
                    onClick={contactWithMail}
                    data-testid="contact-us-md"
                  >
                    <FormattedMessage id="internalErrorContact" />
                  </Button>
                </div>
                <div className="d-block d-md-none">
                  <Button
                    className="btn btn-xl btn-primary btn-block mb-1"
                    onClick={() => navigate(-1)}
                    data-testid="try-again"
                  >
                    <FormattedMessage id="internalErrorTryAgain" />
                  </Button>
                  <Button
                    className="btn btn-xl btn-flat-secondary ms-1 btn-block"
                    onClick={contactWithMail}
                    data-testid="contact-us"
                  >
                    <FormattedMessage id="internalErrorContact" />
                  </Button>
                </div>
              </div>
              <div className="col-4 px-0 position-relative">
                <div className={`d-none d-lg-block ${styles.internalErrorImage}`}></div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default InternalErrorPage;
